export default __webpack_public_path__ + "static/clean-ingredients_experts_Joy-Bauer-dc41dd864a2cfb001554e2d63abff046.png";